"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.MatrixAsset = void 0;
const react_1 = __importDefault(require("react"));
const resource_browser_1 = require("@squiz/resource-browser");
const InputContainer_1 = require("../InputContainer/InputContainer");
const MatrixAsset = ({ modalTitle, allowedTypes, value, onChange, ...props }) => {
    return (react_1.default.createElement(InputContainer_1.InputContainer, { ...props },
        react_1.default.createElement(resource_browser_1.ResourceBrowser, { modalTitle: modalTitle, allowedTypes: allowedTypes, value: value && value.matrixIdentifier && value.matrixAssetId
                ? {
                    sourceId: value.matrixIdentifier,
                    resourceId: value.matrixAssetId,
                }
                : null, onChange: (resource) => {
                onChange({
                    target: {
                        value: {
                            ...value,
                            matrixIdentifier: resource?.source?.id,
                            matrixAssetId: resource?.id,
                            url: resource?.url,
                        },
                    },
                });
            } })));
};
exports.MatrixAsset = MatrixAsset;
